import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";

import { NotificationType } from "../../../../../apis/networkdashboard/graphql/graphql";

@Component({
  selector: "malfunction-item",
  templateUrl: "malfunction-item.html",
  styleUrl: "../../shortcut-menu.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class MalfunctionItem {
  private router = inject(Router);

  protected subscription = input.required<{ product: { type: string }; subscriptionId: string }>();
  protected messages = input.required<NotificationType[]>();

  redirectToMalfunction() {
    this.router.navigate([
      "/storing-en-onderhoud/" + this.subscription().product.type + "/" + this.subscription().subscriptionId,
    ]);
  }
}
